export default __webpack_public_path__ + "static/media/ic_city.d9043af1.svg";